import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import authReducer from './auth';
import frontReducer from './front';
import lookupReducer from './lookup';
import socialReducer from './social';
import statusReducer from './status';

export const rootReducer = combineReducers({
    authentication: authReducer,
    form: formReducer,
    frontend: frontReducer,
    gaSettings: (state = {}) => state,
    isCheckoutRequest: (state = false) => state,
    lookup: lookupReducer,
    routing: routerReducer,
    social: socialReducer,
    socialDataMock: (state = {}) => state,
    status: statusReducer,
});
